import {
  Card,
  CardContent,
  CardHeader,
  Container,
  FormHelperText,
} from "@mui/material";
import { FC, useCallback, useState } from "react";
import { useTitlePage } from "../../hooks/use-title-page";
import { FirebaseError } from "firebase/app";
import { signInWithPopup } from "firebase/auth";
import { auth, googleAuthProvider, AppleProvider } from "../../firebase";
import { Apple, Google } from "@mui/icons-material";
import ButtonLoading from "../../components/helpers/ButtonLoading";

const LoginPage: FC = () => {
  useTitlePage("Login Page");

  const [errorMessage, setErrorMessage] = useState("");

  const signInWithGoogle = useCallback(async () => {
    try {
      setErrorMessage("");
      await signInWithPopup(auth, googleAuthProvider);
    } catch (error) {
      if (error instanceof FirebaseError) {
        console.error(error);
        setErrorMessage(error.message);
      } else {
        console.error(error);
        setErrorMessage("שגיאה בעת התחברות");
      }
    }
  }, []);

  const signInWithApple = useCallback(async () => {
    try {
      setErrorMessage("");
      await signInWithPopup(auth, AppleProvider);
    } catch (error) {
      if (error instanceof FirebaseError) {
        console.error(error);
        setErrorMessage(error.message);
      } else {
        console.error(error);
        setErrorMessage("שגיאה בעת התחברות");
      }
    }
  }, []);

  return (
    <Container
      maxWidth="xs"
      dir="rtl"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
      }}
    >
      <Card elevation={4}>
        <CardHeader
          title="התחברות"
          sx={{
            textAlign: "center",
          }}
        />
        <CardContent>
          <ButtonLoading
            fullWidth
            size="large"
            sx={{ mt: 3 }}
            variant="contained"
            btnText="התחברות עם חשבון גוגל"
            loadingText="מתחבר..."
            onClick={signInWithGoogle}
            btnIcon={<Google />}
          />
          <ButtonLoading
            fullWidth
            color="success"
            size="large"
            sx={{ mt: 3 }}
            variant="contained"
            btnText="התחברות עם חשבון אפל"
            loadingText="מתחבר..."
            onClick={signInWithApple}
            btnIcon={<Apple />}
          />
          {!!errorMessage && (
            <FormHelperText error sx={{ mt: 3 }}>
              {errorMessage}
            </FormHelperText>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default LoginPage;
